import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";

import SchoolFaq from "@/components/SchoolFaq/SchoolFaq";
import StudentLoanFinance from "@/components/StudentLoanFinance/StudentLoanFinance";
import StudentLoanPartner from "@/components/StudentLoanPartner/StudentLoanPartner";
import StudentLoansEduJourney from "@/components/StudentLoansEduJourney/StudentLoansEduJourney";
import StudentLoansHero from "@/components/StudentLoansHero/StudentLoansHero";
import StudentsLoanFeedBack from "@/components/StudentsLoanFeedBack/StudentsLoanFeedBack";
import { fetchSchoolFundingData } from "@/services/CmsService";
import Layout from "@/components/Layout/Layout";
import PopupForm from "@/components/PopupForm/PopupForm";
import usePopupVisibility from "@/components/PopupForm/usePopupVisibility";
import { fetchCommonData } from "@/services/CommonService";
import StickyFooter from "@/components/StickyFooter/StickyFooter";

const StudentLoans = ({ sfData, commonData }: any) => {
  const { isPopupVisible, hidePopup } = usePopupVisibility();

  const StickyFooterComponent = sfData?.sticky_footer?.is_sticky_footer_enabled
    ? sfData?.sticky_footer
    : commonData?.sticky_footer?.is_sticky_footer_enabled
    ? commonData?.sticky_footer
    : null;

  return (
    <Layout
      SeoData={sfData?.seo_data}
      commonData={commonData}
      schemaFaq={sfData?.frequently_asked_questions.questions}
    >
      {isPopupVisible && (
        <PopupForm isVisible={isPopupVisible} onClose={hidePopup} />
      )}
      {sfData?.banner && <StudentLoansHero data={sfData?.banner} />}
      <div className="breadCrumbStyle">
        <Breadcrumbs classValue="boxStyle" />
      </div>
      {sfData?.empowering_your_education_card && (
        <StudentLoansEduJourney
          data={sfData?.empowering_your_education_card}
          note={sfData?.note_text}
        />
      )}
      {sfData?.our_load_partner_card && (
        <StudentLoanPartner data={sfData?.our_load_partner_card} />
      )}
      {sfData?.funding_cards && (
        <StudentLoanFinance data={sfData?.funding_cards} />
      )}
      {/* {sfData?.fundi_card && (
        <StudentLoanEduFinance
          handleEnrollButtonClick={showPopup}
          data={sfData?.fundi_card}
        />
      )}
      {sfData?.ed_for_all_card && (
        <StudentLoanByReg
          handleEnrollButtonClick={showPopup}
          data={sfData?.ed_for_all_card}
        />
      )} */}
      {sfData?.a_world_card_section && (
        <StudentsLoanFeedBack data={sfData?.a_world_card_section} />
      )}
      {sfData?.frequently_asked_questions && (
        <SchoolFaq data={sfData?.frequently_asked_questions} />
      )}
      {StickyFooterComponent && <StickyFooter data={StickyFooterComponent} />}
    </Layout>
  );
};

export default StudentLoans;

export async function getServerSideProps() {
  try {
    const sfData = await fetchSchoolFundingData();
    const response = await fetchCommonData();

    return {
      props: {
        sfData: sfData?.data,
        commonData: response.data,
      },
    };
  } catch (error) {
    console.error("Error fetching CMS data:", error);
  }
}
